module.exports = __webpack_public_path__ + "static/z_tall_si_jay-81a297870a071bf23d6f64d8d1bff34d.jpg";